import LanguageDetector, { type DetectorOptions } from 'i18next-browser-languagedetector'

const queryStringDetectorName = 'customQueryString'
const primaryDetectorName = 'detectPrimary'

/**
 * Clients all around Europe are using an underscore notation. #makeitwork
 */
const applyCompatibility = (lang: string) => lang.replace('_', '-')

export const languageDetector = (localesForDomain: () => string[]) => {
  const detector = new LanguageDetector()

  detector.addDetector({
    name: queryStringDetectorName,
    lookup(options: DetectorOptions) {
      const underlying = detector.detectors.querystring
      if (!underlying) {
        return
      }

      const lang = underlying.lookup(options)

      // eslint-disable-next-line consistent-return
      return lang ? applyCompatibility(lang) : undefined
    },
  })

  detector.addDetector({
    name: primaryDetectorName,
    lookup() {
      const underlying = detector.detectors.navigator

      if (!underlying) {
        return
      }

      const navigatorLocales: string[] = underlying.lookup()

      // The locales looked up from browser contain i.e. ['nl', 'en-GB', 'en', 'en-US', 'nl'].
      // We need to map this to a corresponding locale available for the current domain.
      const availableNavigatorLocales = navigatorLocales
        .map((locale) => localesForDomain().find((l) => l.startsWith(locale)))
        .filter(Boolean) as string[] | undefined

      // eslint-disable-next-line consistent-return
      return availableNavigatorLocales?.find((locale) => localesForDomain().includes(locale)) ?? localesForDomain()[0]
    },
  })

  return detector
}

export const customDetectors = {
  detectPrimary: primaryDetectorName,
  queryString: queryStringDetectorName,
}
